import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import PosSection from "./posSection/PosSection";
import GridItem from "./displaySection/GridItem";

class Sale extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div>
        {/* Left side carts grid and barcode/search text box  */}
        <div >
          {/* <PosSection /> */}
          
        </div>

        {/* Right side products display grid */}
        {/* <div className={classes.items}>
          <GridItem />
        </div> */}
        <table className="customtable">
            <thead className="customthead">
            <tr className="customtr">
              <th>State</th>
              <th>Postcode</th>
              <th>Total YTD Billing (RM)</th>
            </tr>
            </thead>
            <tr className="customtr">
              <td>Selangor</td>
              <td>40000</td>
			  <td>1,023,422.00</td>
            </tr>
            <tr className="customtr">
              <td>Selangor</td>
              <td>40170</td>
			  <td>823,422.00</td>
            </tr>
            <tr className="customtr">
              <td>Selangor</td>
              <td>47400</td>
			  <td>1,923,452.00</td>
            </tr>
            <tr className="customtr">
              <td>Selangor</td>
              <td>40300</td>
			  <td>1,223,479.00</td>
            </tr>
          </table>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Sale);



// WEBPACK FOOTER //
// ./src/components/sale/index.js